import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import * as VueGoogleMaps from 'vue2-google-maps'
import VDragged from 'v-dragged'
import VueCompositionApi from '@vue/composition-api'
import Vuelidate from 'vuelidate'
import myFilter from './plugins/filters'
import vuescroll from 'vuescroll'
import ScrollLoader from 'vue-scroll-loader'
import resizeimg from './plugins/resizeimg'
import globalFunction from './plugins/globalFunction'
import env from '../env'
import axios from './plugins/axios'

// == import global ui conponent ==
import BtnVisitStatus from './components/v2/ui/ButtonVisitStatus.vue'
import BtnVisitDate from './components/v2/ui/ButtonVisitDate.vue'
import BtnVisitPlan from './components/v2/ui/ButtonVisitPlan.vue'
import BaseIconSite from './components/v2/ui/BaseIconSite.vue'
import BaseIconPin from './components/v2/ui/BaseIconPin.vue'

Vue.use(ScrollLoader)
Vue.use(vuescroll)
Vue.use(Vuelidate)
Vue.use(VDragged)
Vue.use(VueCompositionApi)
Vue.filter('shortname', myFilter.shortname)
Vue.filter('convertMonth', myFilter.convertMonth)
Vue.filter('toTwoDigit', myFilter.toTwoDigit)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAr2i-W3Qf7RCH_gq4pg4cQeKVsH1LdtyM',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    region: 'TH',
    language: 'th',
  },
})
Vue.config.productionTip = false

Vue.component('btn-visit-status', BtnVisitStatus)
Vue.component('btn-visit-date', BtnVisitDate)
Vue.component('btn-visit-plan', BtnVisitPlan)
Vue.component('base-icon-site', BaseIconSite)
Vue.component('base-icon-pin', BaseIconPin)

// plugins
axios()

new Vue({
  env,
  router,
  store,
  vuetify,
  resizeimg,
  globalFunction,
  render: (h) => h(App),
}).$mount('#app')
